// extracted by mini-css-extract-plugin
module.exports = {"container":"AuditDashboardTab_container_2rXjg","spinAround":"AuditDashboardTab_spinAround_1PtJo"};